import * as z from "zod"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(z.string(), jsonSchema)]))

export const source_catalogDbModel = z.object({
  package: z.string(),
  version: z.string(),
  key: z.string(),
  catalog: jsonSchema,
  timestamp: z.coerce.date(),
  status: z.string(),
  description: z.string().nullish(),
})
